import { React, useAppI18N } from '@/app'
import { Button } from '@/components'
import { AnyFunction } from '@codeleap/types'
import { maybeOpenRegistrationWall } from '@/features/Auth/session/registrationWall'

export const LoginButton = React.memo((props: { onLeave?: AnyFunction }) => {
  const { t } = useAppI18N()

  const onPress = () => {
    maybeOpenRegistrationWall()
    props.onLeave?.()
  }

  return <Button variants={['fullWidth']} text={t('login')} debugName={`Modal done continue`} onPress={onPress} />
})
